import * as React from "react";
import type { SVGProps } from "react";
const SvgBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 19c0 .55.45 1 1 1s1-.45 1-1v-1h16v1c0 .55.45 1 1 1s1-.45 1-1v-6c0-1.65-1.35-3-3-3h-8.172c.111-.313.172-.65.172-1 0-1.65-1.35-3-3-3H5c-.35 0-.687.06-1 .172V5c0-.55-.45-1-1-1s-1 .45-1 1zm2-7v4h16v-3c0-.55-.45-1-1-1zm1-2c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBed;
